export default "__VITE_PUBLIC_ASSET__b3cc425d__"